import {Controller} from 'stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['template', 'container', 'fields', 'schoolInfo',
                    'schoolCode', 'schoolRegion', 'schoolParish', 'schoolType',
                    'bookTitle', 'bookSubject', 'bookGrade', 'schoolSelect']
  static values = { school: Number }

  connect () {
    if (this.hasSchoolSelectTarget) {
      $(this.schoolSelectTarget).on('change', (e) => this.schoolChanged(e))
    }
  }

  disconnect () {
    if (this.hasSchoolSelectTarget) {
      $(this.schoolSelectTarget).off('change')
    }
  }

  add ({ title, subject, grade }) {
    const html = this.templateTarget.innerHTML
          .replace(/CHILD_INDEX/g, new Date().valueOf())
          .replace(/CHILD_TITLE/g, title || '')
          .replace(/CHILD_SUBJECT/g, subject || '-')
          .replace(/CHILD_GRADE/g, grade || '-')
    this.containerTarget.insertAdjacentHTML('beforeend', html)

    // Set hidden field values
    const fields = this.containerTarget.lastElementChild
    fields.querySelector('input[name*="[book_title]"]').value = title
    fields.querySelector('input[name*="[subject]"]').value = subject || ''
    fields.querySelector('input[name*="[grade]"]').value = grade || ''
  }

  remove (event) {
    event.preventDefault()
    const fields = event.target.closest('[data-target="book-damage-submission.fields"]')
    fields.remove()
    event.target.blur()
  }

  getAddedTitles () {
    const titles = []
    this.containerTarget.querySelectorAll('input[name*="[book_title]"]').forEach(input => {
      if (input.value) titles.push(input.value)
    })
    return titles
  }

  async schoolChanged (event) {
    const schoolId = event.target.value
    if (!schoolId) {
      this.schoolInfoTarget.classList.add('d-none')
      return
    }

    try {
      const response = await fetch(`/schools/${schoolId}.json`)
      const school = await response.json()

      this.schoolCodeTarget.textContent = school.code || ''
      this.schoolRegionTarget.textContent = school.formatted_region || ''
      this.schoolParishTarget.textContent = school.formatted_parish || ''
      this.schoolTypeTarget.textContent = school.type || ''
      this.schoolInfoTarget.classList.remove('d-none')
    } catch (e) {
      console.error('Failed to fetch school info:', e)
    }
  }
}
